import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export const resolveKpiColor = (theme: Theme, index: number): string => {
  switch (index) {
    case 0:
      // Light brand wash — readable with default text; avoid primary.main on tile background.
      // @ts-expect-error theme extends primary with 50–900 (see styles/theme.js)
      return theme.palette.primary[50];
    case 1:
      // @ts-expect-error extended secondary scale
      return theme.palette.secondary[100];
    case 2:
      // @ts-expect-error extended secondary scale
      return theme.palette.secondary[200];
    default:
      return theme.palette.grey[300];
  }
};

const useStyles = makeStyles(theme => ({
  helpBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
  },
  kpiGrid: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    width: '100%',
  },
  kpiTileOuter: {
    display: 'flex',
    height: '100%',
    minHeight: theme.spacing(16),
  },
  kpiTile: {
    width: '100%',
  },
  errorBanner: {
    marginBottom: theme.spacing(2),
  },
  forbiddenState: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    maxWidth: 560,
  },
  forbiddenBackButton: {
    marginTop: theme.spacing(2),
  },
  emptyState: {
    marginTop: theme.spacing(2),
  },
  hoverList: {
    margin: 0,
    paddingLeft: theme.spacing(2),
  },
  tableDrillLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));

export default useStyles;
